module.exports = __webpack_public_path__ + "img/courier-canpar.7553e5b3.svg";